import { NOTIFYER_WHATSAPP_CONNECTION_URL } from "../../redux/reducers/authSlice";
import AuthStatusScreen from "./AuthStatusScreen";

export default function WhatsAppConnectionRequiredScreen() {
  return (
    <AuthStatusScreen
      title="Connect WhatsApp number"
      description="Add and verify your WhatsApp Business number in Notifyer to start chatting from Pipedrive."
    >
      <a
        href={NOTIFYER_WHATSAPP_CONNECTION_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-7 inline-flex w-full items-center justify-center rounded-lg bg-[#25D366] px-4 py-3 text-sm font-semibold text-white transition hover:bg-[#20bd5a]"
      >
        Connect WhatsApp number
      </a>
      <p className="mt-4 text-xs text-gray-400">
        After connecting, reload this app from Pipedrive.
      </p>
    </AuthStatusScreen>
  );
}
